import { getCountries } from 'country-state-picker';

/**
 * Debounce delay (ms) for search requests sent through the BFF proxy to the
 * Asset Management API.
 * This delay is intentionally longer because the API scans a large dataset and
 * should be called less frequently.
 */
export const API_SEARCH_DEBOUNCE_DELAY_MS = 600;

/**
 * `selectedIds` for a single-select KDS `DropdownList` used as an action menu.
 * An uncontrolled one keeps the last pick checked on reopen, and a checked
 * option can't be picked again, so the same action couldn't run twice.
 * Prefer `components/ActionsMenu`; use this only where an item needs
 * `renderOptionLabel`, which Menu can't render.
 * Module-level so the reference stays stable across renders.
 */
export const NO_SELECTION: string[] = [];

/**
 * List of allowed country codes. These values maps the available countries in
 * the `case` app.
 * Used in Sentinel's `Management` module.
 */
export const ALLOWED_COUNTRIES = ['US', 'CA', 'EC', 'MX', 'CL', 'JP'];

export const COUNTRY_OPTIONS = getCountries()
  .filter(({ code }: { code: string }) =>
    ALLOWED_COUNTRIES.includes(code.toUpperCase()),
  )
  .map(({ code, name }: { code: string; name: string }) => ({
    id: code.toUpperCase(),
    label: name,
    value: code.toUpperCase(),
  }));

export const DIAL_CODE_OPTIONS = [
  { id: '+1', label: '+1 (US/CA)', value: '+1' },
  { id: '+52', label: '+52 (MX)', value: '+52' },
  { id: '+56', label: '+56 (CL)', value: '+56' },
  { id: '+593', label: '+593 (EC)', value: '+593' },
  { id: '+81', label: '+81 (JP)', value: '+81' },
];
